import { HttpClient } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil, tap } from 'rxjs/operators';
import { EmailNewOrgAdd } from 'src/app/models/Emails.model';
import { EmailType } from 'src/app/models/enums/email-type.enum';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import {
    Dropdown,
    Organization,
    organizationAddress,
    OrganizationIds,
    profileContactModel,
    profileContractModel,
} from 'src/app/Modules/management/models/organization/organization.model';
import { ManagementApiService } from 'src/app/services';
import { EmailSenderService } from 'src/app/services/email-sender.service';
import { OrganizationDataService } from 'src/app/services/organization-data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { ConfirmationDialogComponent } from 'src/app/shared/info-dialogs/confirmation-dialog/confirmation-dialog.component';
import { DeleteDialogComponent } from 'src/app/shared/info-dialogs/delete-dialog/delete-dialog.component';
import { OrganizationTransaction } from '../../../enums/organization-transction.enum';
import { GlobalEmittersService } from '../../../../../services/global-emitters.service';
import { ImageCropModelComponent } from '../../modals/organization/image-crop-model/image-crop-model.component';
import { CustomValidatorService } from 'src/app/services/custom-validator.service';
import { PermissionHierarchy } from 'src/app/Modules/idms/models/security-role-permission.model';
import { CustomToastService } from 'src/app/services/custom-toast.service';

@Component({
    selector: 'app-organization-wizard-details',
    templateUrl: './organization-wizard-details.component.html',
    styleUrls: ['./organization-wizard-details.component.scss'],
})
export class OrganizationWizardDetailsComponent implements OnInit, OnDestroy {
    @Output() isFederatedOrganization = new EventEmitter<boolean>();
    @Output() valueChangeFlag = new EventEmitter<boolean>();
    @Output() navigateToUser = new EventEmitter<number>();
    @Output() OrgData = new EventEmitter<Organization>();
    @Output() formStatusChange = new EventEmitter<boolean>();
    @ViewChild(MatAutocompleteTrigger, { read: MatAutocompleteTrigger }) inputAutoComplete: MatAutocompleteTrigger;
    isSubscribe: Subject<any> = new Subject<any>();
    url: any;
    addOrganizationFrom: UntypedFormGroup;
    minDateStart: any = new Date();
    formData = new FormData();
    selectedFile: File | '';
    organizationData: Organization; //organization get from the response
    isOrganizationSaved: boolean = false;
    updateOrganization: boolean = false;
    isEditOrganization: boolean = false;
    avatarName: string;
    profileContactFirstName = [];
    profileContactLastName = [];
    profileContactEmail = [];
    currentProfileAutoComplete: profileContactModel;
    profileAutoCompletionData: profileContactModel[] = [];
    searchText: string;
    isAutoComplete: boolean = false;
    organizationIds: OrganizationIds = {
        organisationId: '',
        profileContractId: '',
        profileContactId: '',
        addressId: '',
    };
    isFederatedCheckbox: boolean = false;
    orgLogo: string;
    isSomethingModified: boolean;
    isEditEnabled: boolean = true;
    frdOrg: boolean;
    country: string[];
    isImgChanged: boolean;
    _jsonURL = '../../../../../../assets/i18n/en.json';
    securityRoleList: PermissionHierarchy[];
    OrganizationId: string = null;
    isEditMode = false;
    constructor(
        private formBuilder: UntypedFormBuilder,
        private managementApiService: ManagementApiService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private organizationDataService: OrganizationDataService,
        private activatedRoute: ActivatedRoute,
        private cd: ChangeDetectorRef,
        private modalService: NgbModal,
        private user_utility: UserUtilityService,
        private http: HttpClient,
        private emailSenderService: EmailSenderService,
        private router: Router,
        private ngbModal: NgbModal,
        private globalEmittersService: GlobalEmittersService,
        private customValidator: CustomValidatorService,
        private userUtilityServices: UserUtilityService,
        private customToastService: CustomToastService
    ) {
        this.isSomethingModified = false;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;

        // this.organizationData = new Organization();
    }

    async ngOnInit(): Promise<void> {
        this.isEditEnabled = await this.user_utility.checkUserPermissionDataAndRoute('edit-organization/:id', userActions.Edit);
        this.activatedRoute.paramMap.subscribe((params) => {
            const id = params.get('id');
            if (id) {
                this.isEditMode = true;
                this.OrganizationId = id;
            } else {
                this.isEditMode = false;
                this.clearState(); // new method for a full reset
            }
        });
        this.initilaizeComp();
        this.handleSubcription();
    }

    handleSubcription() {
        this.getCountry().subscribe((res) => {
            this.country = Object.keys(res.ORG_DETAILS.COUNTRY).map((k) => res.ORG_DETAILS.COUNTRY[k]);
        });

        this.organizationDataService.isFederatedOrganization$.pipe(takeUntil(this.isSubscribe)).subscribe((res) => {
            this.frdOrg = res;
        });
        if (this.OrganizationId) {
            this.organizationDataService.organizationTabNext.pipe(takeUntil(this.isSubscribe), distinctUntilChanged()).subscribe((resp) => {
                if (resp == 'Details') {
                    this.saveOrganizationData();
                    this.organizationDataService.organizationTabNext.next(null);
                }
            });
        } else {
            this.organizationDataService.organizationTabNextCreate.pipe(takeUntil(this.isSubscribe), distinctUntilChanged()).subscribe((resp) => {
                if (resp == 'Details') {
                    this.saveOrganizationData();
                    this.organizationDataService.organizationTabNextCreate.next(null);
                }
            });
        }
        let selectedOrgId = localStorage.getItem('selectedOrgId');
        let orgID = selectedOrgId && selectedOrgId.length ? selectedOrgId : this.OrganizationId;
        if (!orgID) {
            this.addOrganizationFrom.statusChanges.subscribe((status) => {
                this.formStatusChange.emit(this.addOrganizationFrom.valid);
            });
        }
    }

    initilaizeComp() {
        let selectedOrgId = localStorage.getItem('selectedOrgId');
        let orgID = selectedOrgId && selectedOrgId.length ? selectedOrgId : this.OrganizationId;
        if (orgID) {
            if (this.router.url == '/management/add-organization') {
                localStorage.removeItem('selectedOrganizationName');
                localStorage.removeItem('selectedOrgId');

                this.globalEmittersService.currentOrg.next(null);
                this.globalEmittersService.currentOrgId.next(null);

                localStorage.removeItem('currentInstanceName');
                localStorage.removeItem('currentInstanceId');

                this.globalEmittersService.currentInstanceName.next(null);
                this.globalEmittersService.currentInstanceId.next(null);
                this.globalEmittersService.selectedCalcType.next(null);

                this.createFormControls();
            } else {
                this.isEditOrganization = true;
                this.isEditOrganization = true;
                let orgID = this.OrganizationId;
                this.organizationDataService.organizationID.next(orgID);
                this.getOrganizationData(orgID);
                this.minDateStart = '';
                this.updateOrganization = true;
                this.valueChangeFlag.emit(false);
                this.organizationDataService.isOrganzationEdit = true;
            }
        } else {
            this.createFormControls();
            //this.organizationData.isFedrated = false;
        }
    }

    async saveOrganizationData() {
        let transactionType = -1;
        if (!this.addOrganizationFrom.invalid) {
            if (
                (this.OrganizationId && this.addOrganizationFrom.dirty && this.isEditMode == true) ||
                (this.addOrganizationFrom.dirty && this.organizationDataService.organizationData?.organisationId)
            ) {
                transactionType = OrganizationTransaction.update;
            } else if (!this.OrganizationId && this.addOrganizationFrom.dirty) {
                transactionType = OrganizationTransaction.add;
            } else if (
                (this.OrganizationId && !this.addOrganizationFrom.dirty && this.isEditMode == true) ||
                (!this.addOrganizationFrom.dirty && this.organizationDataService.organizationData?.organisationId)
            ) {
                transactionType = OrganizationTransaction.navigate;
            }
        } else {
            this.addOrganizationFrom.markAllAsTouched();
            return;
        }

        switch (transactionType) {
            case OrganizationTransaction.add:
                this.createFormDataInForm();
                if (this.addOrganizationFrom.get('federated_organization').value === true) {
                    this.organizationDataService.orgNavigationHandler(1);
                } else {
                    try {
                        this.ngxUiLoaderService.start();
                        let orgRes = await this.managementApiService.addOrganization(this.formData).toPromise();

                        if (orgRes.success == true) {
                            this.globalEmittersService.currentOrganization.next(orgRes.response); // * used for manage security roles based on license number
                            this.organizationDataService.instanceLimit.next(orgRes.response.instanceLimit);
                            // await this.addDefaultSecurityRoles();
                            this.addOrganizationFrom.reset(this.addOrganizationFrom.value); // * changing the form status property
                            this.ngxUiLoaderService.stop();
                            this.isImgChanged = false;
                            this.organizationDataService.organizationID.next(orgRes.response.organisationId);
                            this.organizationDataService.organizationData = orgRes.response;
                            this.organizationData = orgRes.response; // * saving org data

                            this.organizationDataService.currentOrganizationName.next(orgRes.response.name);
                            this.globalEmittersService.currentOrg.next(orgRes.response.name);
                            this.globalEmittersService.currentOrgId.next(orgRes.response.organisationId);
                            this.organizationDataService.currentOrgId = orgRes.response.organisationId;
                            this.organizationDataService.currentOrg = orgRes.response.name;
                            localStorage.setItem('selectedOrganizationName', orgRes.response.name);
                            localStorage.setItem('selectedOrgId', orgRes.response.organisationId);
                            // removing the current instance stored in local storage because each organization has different instances
                            // on selection on new organization previously selected have to removed
                            if (localStorage.getItem('currentInstanceName')) {
                                localStorage.removeItem('currentInstanceName');
                                localStorage.removeItem('currentInstanceId');
                                this.globalEmittersService.currentInstanceName.next(null);
                            }

                            this.triggerEmail(); // * sending mail
                            this.getDefaultSecurityRoles();
                        } else if (orgRes.isCustom) {
                            this.ngxUiLoaderService.stop();
                            this.user_utility.errorModelPopup(orgRes.message);
                        }
                    } catch (e) {
                        this.ngxUiLoaderService.stop();
                        this.user_utility.errorModelPopup(e.message);
                    }
                }
                break;

            case OrganizationTransaction.update:
                this.createFormDataInForm();
                if (!this.organizationDataService.formData.has('organisation[OrganisationId]')) {
                    this.organizationDataService.formData.append('organisation[OrganisationId]', this.organizationDataService.organizationData.organisationId);
                }
                if (!this.organizationDataService.formData.has('organisation[ProfileContract][ProfileContractId]')) {
                    this.organizationDataService.formData.append(
                        'organisation[ProfileContract][ProfileContractId]',
                        this.organizationDataService.organizationData?.profileContract?.profileContractId
                    );
                }
                if (!this.organizationDataService.formData.has('organisation[ProfileContract][ProfileContact][ProfileContactId]')) {
                    this.organizationDataService.formData.append(
                        'organisation[ProfileContract][ProfileContact][ProfileContactId]',
                        this.organizationDataService.organizationData?.profileContract.profileContact.profileContactId
                    );
                }
                if (!this.organizationDataService.formData.has('organisation[ProfileContract][ProfileContact][Address][AddressId]')) {
                    this.organizationDataService.formData.append(
                        'organisation[ProfileContract][ProfileContact][Address][AddressId]',
                        this.organizationDataService.organizationData.profileContract.profileContact?.address?.addressId
                    );
                }
                try {
                    this.ngxUiLoaderService.start();
                    let orgRes = await this.managementApiService.updateOrganization(this.formData).toPromise();

                    if (orgRes.success) {
                        this.isImgChanged = false;
                        this.ngxUiLoaderService.stop();
                        await this.getOrganizationData(this.organizationDataService.organizationData.organisationId); // * updating our property with updated org info
                        if (this.addOrganizationFrom.get('federated_organization').value) {
                            this.organizationDataService.orgNavigationHandler(1);
                        } else {
                            this.organizationDataService.orgNavigationHandler(0);
                        }
                    } else if (orgRes.isCustom) {
                        if (this.organizationData.logo) {
                            this.orgLogo = this.organizationData.logo;
                        }
                        this.ngxUiLoaderService.stop();
                        this.user_utility.errorModelPopup(orgRes.message);
                    }
                } catch (e) {
                    this.ngxUiLoaderService.stop();
                    this.user_utility.errorModelPopup(e.message);
                }
                break;

            case OrganizationTransaction.navigate:
                if (this.addOrganizationFrom.get('federated_organization').value) {
                    this.organizationDataService.orgNavigationHandler(1);
                } else {
                    this.organizationDataService.orgNavigationHandler(0);
                }
                break;
        }
    }

    async getDefaultSecurityRoles() {
        try {
            this.ngxUiLoaderService.start();
            let securityRoles = await this.managementApiService.getSecurityRolesPermissionTemplate(true).toPromise();

            this.ngxUiLoaderService.stop();
            if (securityRoles.success === true) {
                this.securityRoleList = securityRoles.response.slice();
                this.saveSecurityRolePermission();
            } else if (securityRoles.message) {
                this.userUtilityServices.errorModelPopup(securityRoles.message);
            }
        } catch (e) {}
    }

    async saveSecurityRolePermission() {
        if (this.securityRoleList?.length > 0) {
            try {
                this.ngxUiLoaderService.start();
                let securityRoles = await this.managementApiService
                    .addSecurityRole(this.organizationDataService.organizationData.organisationId, this.securityRoleList)
                    .toPromise();

                if (securityRoles.success === true) {
                    this.securityRoleList = [];
                    this.organizationDataService.setUserSecurityRoles(this.securityRoleList);
                    this.organizationDataService.updateisSecurityRoleSaved.next(true);
                    this.ngxUiLoaderService.stop();
                    this.organizationDataService.navigateThroughWizard.next(1); // * navigate to next tab
                    this.setOrganizationIds(); // * setting up respective id's
                    if (this.addOrganizationFrom.get('federated_organization').value) {
                        this.organizationDataService.orgNavigationHandler(1);
                    } else {
                        this.organizationDataService.orgNavigationHandler(0);
                    }
                } else if (securityRoles.message) {
                    this.ngxUiLoaderService.stop();
                    this.userUtilityServices.errorModelPopup(securityRoles.message);
                }
            } catch (e) {
                this.ngxUiLoaderService.stop();
                this.userUtilityServices.errorModelPopup(e.message);
            }
        }
    }

    getOrganizationFormValues() {
        this.formData = new FormData();
        let organizationData = new Organization();
        let profileContactData = new profileContactModel();
        let address = new organizationAddress();
        let profileContractData = new profileContractModel();

        //organization details
        organizationData.name = this.addOrganizationFrom.value.organization_name;
        organizationData.licenseLimitiDMS = this.addOrganizationFrom.value.number_of_iDMS_licenses;
        organizationData.instanceLimit = this.addOrganizationFrom.value.number_of_instances;
        organizationData.sfdcCustomerNumber = this.addOrganizationFrom.value.sfdc_customer_number;
        organizationData.licenseLimitICE = this.addOrganizationFrom.value.number_of_ICE_licenses;

        //profileContact details
        profileContactData.firstName = this.addOrganizationFrom.value.contact_holder_first_name;
        profileContactData.lastName = this.addOrganizationFrom.value.contact_holder_last_name;
        profileContactData.jobTitle = this.addOrganizationFrom.value.contact_holder_job_title;
        profileContactData.telephone = this.addOrganizationFrom.value.contact_holder_telephone;
        profileContactData.email = this.addOrganizationFrom.value.contact_holder_email;
        address.line1 = this.addOrganizationFrom.value.contact_holder_address_line1;
        address.line2 = this.addOrganizationFrom.value.contact_holder_address_line2;
        address.city = this.addOrganizationFrom.value.contact_holder_city;
        address.state = this.addOrganizationFrom.value.contact_holder_state;
        address.country = this.addOrganizationFrom.value.contact_holder_country;
        address.zipcode = this.addOrganizationFrom.value.contact_holder_zipcode;

        //profileContract details
        profileContractData.name = this.addOrganizationFrom.value.contract_holder_name;
        profileContractData.startDate = this.addOrganizationFrom.value.start_date.toDateString();
        profileContractData.endDate = this.addOrganizationFrom.value.end_date.toDateString();
        profileContractData.description = this.addOrganizationFrom.value.organization_description;
        profileContractData.profileContact = profileContactData;

        // profileContactData.AddressId = "3defeaee-9197-4b93-8a78-9333f882330b";
        profileContactData.address = address;
        organizationData.profileContact = profileContactData;
        organizationData.profileContract = profileContractData;

        organizationData.isFedrated = this.addOrganizationFrom.value.federated_organization;

        //if the organization is already added then retrieve the necessary IDs from object
        if (this.organizationData) {
            organizationData.organisationId = this.organizationData.organisationId;
            profileContactData.profileContactId = this.organizationData.profileContract.profileContact.profileContactId;
            profileContractData.profileContractId = this.organizationData.profileContract.profileContractId;
            address.addressId = this.organizationData.profileContract.profileContact.address.addressId;
            organizationData.profileContractId = this.organizationData.profileContract.profileContractId;
            profileContactData.addressId = this.organizationData.profileContract.profileContact.address.addressId;
            if (this.selectedFile) {
                // let logoProfileImage = new ProfileImage();
                // logoProfileImage.profileImageId = (this.organizationData.logoProfileImageId)?this.organizationData.logoProfileImageId:'00000000-0000-0000-0000-000000000000';
                // organizationData.logoProfileImageId = (this.organizationData.logoProfileImageId)?this.organizationData.logoProfileImageId:'00000000-0000-0000-0000-000000000000';
                // organizationData.logoProfileImage = logoProfileImage;
            }
        }

        return organizationData;
    }

    onSelectFile(event) {
        let file = <File>event.target.files[0];
        let allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
        let errorMessage = 'Please select a .jpeg, .jpg, .png, .webp file.';
        if (!allowedTypes.includes(file.type)) {
            this.customToastService.errorToast(errorMessage, 'Error');
            return;
        }
        if (event.target.files.length) {
            let dialogRef = this.modalService.open(ImageCropModelComponent, {
                backdrop: 'static',
                size: 'lg',
            });
            dialogRef.componentInstance.imageChangedEvent = event;
            dialogRef.componentInstance.imgType = 'logo';
            dialogRef.componentInstance.ImageArray = [];
            dialogRef.result
                .then((response) => {
                    if (response) {
                        this.url = response[0].url;
                        this.orgLogo = response[0].url;
                        this.addOrganizationFrom.markAsDirty();
                        this.isImgChanged = true;
                        this.selectedFile = response[0].file;
                        this.cd.detectChanges();
                    }
                })
                .catch((e) => {
                    console.warn(e);
                });
        }
    }

    deleteSelectedImage(): void {
        let dialogRef = this.modalService.open(DeleteDialogComponent, { size: 'sm' });
        dialogRef.componentInstance.modalMessage = 'Are you sure you want remove the image?';
        dialogRef.result
            .then((res) => {
                if (res) {
                    this.selectedFile = '';

                    this.isSomethingModified = true;
                    this.isImgChanged = true;
                    this.addOrganizationFrom.markAsDirty();
                    this.orgLogo = null;
                }
            })
            .catch((e) => {
                console.warn(e);
            });
    }

    createFormControls() {
        this.addOrganizationFrom = this.formBuilder.group({
            organization_name: new UntypedFormControl(null, [Validators.required, Validators.max(255)]),
            sfdc_customer_number: new UntypedFormControl(null, [Validators.required]),
            contact_holder_first_name: new UntypedFormControl(null, [Validators.required, Validators.maxLength(255)]),
            contact_holder_last_name: new UntypedFormControl(null, [Validators.required, Validators.maxLength(255)]),
            contact_holder_job_title: new UntypedFormControl(null, [Validators.required, Validators.maxLength(255)]),
            contact_holder_telephone: new UntypedFormControl(null, [Validators.required, Validators.maxLength(50)]),
            contact_holder_email: new UntypedFormControl(null, [Validators.email, Validators.required, Validators.maxLength(50)]),
            contact_holder_address_line1: new UntypedFormControl(null, [Validators.required, Validators.maxLength(255)]),
            contact_holder_address_line2: new UntypedFormControl(null, [Validators.maxLength(255)]),
            contact_holder_city: new UntypedFormControl(null, [Validators.required, Validators.maxLength(255)]),
            contact_holder_state: new UntypedFormControl(null, [Validators.required, Validators.maxLength(255)]),
            contact_holder_country: new UntypedFormControl(null, [Validators.required, Validators.maxLength(255)]),
            contact_holder_zipcode: new UntypedFormControl(null, [Validators.required, Validators.maxLength(50)]),
            number_of_instances: new UntypedFormControl(null, [Validators.required, Validators.min(1)]),
            number_of_ICE_licenses: new UntypedFormControl(null, [Validators.required, Validators.min(0)]),
            number_of_iDMS_licenses: new UntypedFormControl(null, [Validators.required, Validators.min(0)]),
            contract_holder_name: new UntypedFormControl(null, [Validators.required, Validators.maxLength(255)]),
            start_date: new UntypedFormControl(null, [Validators.required]),
            end_date: new UntypedFormControl(null, [Validators.required]),
            organization_description: new UntypedFormControl(null, [Validators.maxLength(1024)]),
            federated_organization: new UntypedFormControl(false),
        });
        this.organizationDataService.isFederatedOrganization$.next(false);
        this.addOrganizationFrom.setValidators(this.comparisonValidator());
        this.initilizeAutoSearch();
        this.addOrganizationFrom.markAllAsTouched();
        this.cd.detectChanges();
    }

    omitSpecialChar(event) {
        let k;
        k = event.charCode;
        return (k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57);
    }
    onKeyPress(event: KeyboardEvent) {
        this.customValidator.validateKeyPress(event);
    }

    detectValueChanges(event) {
        if (this.isOrganizationSaved || this.updateOrganization) {
            this.valueChangeFlag.emit(true);
            this.isOrganizationSaved = true;
            this.updateOrganization = true;
            this.organizationDataService.isDisableUserTypeWizard.next(true);
            this.organizationDataService.isDisableAzureDetailWizard.next(true);
            this.organizationDataService.isDisableUsersWizard.next(true);
            this.isSomethingModified = true;
        }
    }

    async getOrganizationData(orgId: string) {
        try {
            this.ngxUiLoaderService.start();
            let organization = await this.managementApiService.getOrganizationById(orgId).toPromise();
            if (organization.success === true) {
                this.organizationDataService.instanceLimit.next(organization.response.instanceLimit);
                if (organization.response.logo) {
                    this.orgLogo = organization.response.logo;
                }
                this.organizationDataService.currentOrganizationName.next(organization.response.name);
                this.organizationDataService.organizationData = organization.response;
                this.organizationData = organization.response;
                this.OrgData.emit(organization.response);
                this.setOrganizationIds();
                if (this.organizationData.azureADIssuerUrl) {
                    this.isFederatedOrganization.emit(true);

                    this.isFederatedCheckbox = true;
                    this.organizationDataService.isFederatedOrganization$.next(true);
                    this.organizationData.isFedrated = true;
                } else {
                    if (this.addOrganizationFrom != null || this.addOrganizationFrom != undefined) {
                        if (this.addOrganizationFrom && this.addOrganizationFrom.get('federated_organization').value) {
                            this.organizationDataService.isFederatedOrganization$.next(true);
                        } else {
                            this.organizationDataService.isFederatedOrganization$.next(false);
                        }
                    } else {
                        this.organizationDataService.isFederatedOrganization$.next(false);
                    }
                }
                this.globalEmittersService.currentOrganization.next(organization.response); // * used for handling security roles based on license number
                this.initEditOrganizationForm(this.organizationData);
                this.ngxUiLoaderService.stop();
            } else {
                this.user_utility.errorModelPopup(organization.message);
            }
        } catch (e) {}
    }

    initEditOrganizationForm(editOrganization: Organization) {
        this.addOrganizationFrom = this.formBuilder.group({
            organization_name: new UntypedFormControl(editOrganization.name, [Validators.required, Validators.max(255)]),
            sfdc_customer_number: new UntypedFormControl(editOrganization.sfdcCustomerNumber, [Validators.required]),
            contact_holder_first_name: new UntypedFormControl(editOrganization.profileContract.profileContact.firstName, [
                Validators.required,
                Validators.maxLength(255),
            ]),
            contact_holder_last_name: new UntypedFormControl(editOrganization.profileContract.profileContact.lastName, [
                Validators.required,
                Validators.maxLength(255),
            ]),
            contact_holder_job_title: new UntypedFormControl(
                editOrganization.profileContract.profileContact.jobTitle === undefined ? '' : editOrganization.profileContract.profileContact.jobTitle,
                [Validators.maxLength(255)]
            ),
            contact_holder_telephone: new UntypedFormControl(
                editOrganization.profileContract.profileContact.telephone === undefined ? '' : editOrganization.profileContract.profileContact.telephone,
                [Validators.maxLength(50)]
            ),
            contact_holder_email: new UntypedFormControl(
                editOrganization.profileContract.profileContact.email === undefined ? '' : editOrganization.profileContract.profileContact.email,
                [Validators.required, Validators.email, Validators.maxLength(50)]
            ),
            contact_holder_address_line1: new UntypedFormControl(editOrganization.profileContract.profileContact.address.line1, [
                Validators.required,
                Validators.maxLength(255),
            ]),
            contact_holder_address_line2: new UntypedFormControl(
                editOrganization.profileContract.profileContact.address.line2 === undefined
                    ? ''
                    : editOrganization.profileContract.profileContact.address.line2,
                [Validators.maxLength(255)]
            ),
            contact_holder_city: new UntypedFormControl(editOrganization.profileContract.profileContact.address.city, [
                Validators.required,
                Validators.maxLength(255),
            ]),
            contact_holder_state: new UntypedFormControl(editOrganization.profileContract.profileContact.address.state, [
                Validators.required,
                Validators.maxLength(255),
            ]),
            contact_holder_country: new UntypedFormControl(editOrganization.profileContract.profileContact.address.country, [
                Validators.required,
                Validators.maxLength(255),
            ]),
            contact_holder_zipcode: new UntypedFormControl(editOrganization.profileContract.profileContact.address.zipcode, [
                Validators.required,
                Validators.maxLength(50),
            ]),
            number_of_instances: new UntypedFormControl(editOrganization.instanceLimit, [Validators.required, Validators.min(1)]),
            number_of_iDMS_licenses: new UntypedFormControl(editOrganization.licenseLimitiDMS, [Validators.required, Validators.min(0)]),
            number_of_ICE_licenses: new UntypedFormControl(editOrganization.licenseLimitICE, [Validators.required, Validators.min(0)]),
            contract_holder_name: new UntypedFormControl(editOrganization.profileContract.name, [Validators.required, Validators.maxLength(255)]),
            start_date: new UntypedFormControl(new Date(editOrganization.profileContract.startDate), [Validators.required]),
            end_date: new UntypedFormControl(new Date(editOrganization.profileContract.endDate), [Validators.required]),
            organization_description: new UntypedFormControl(
                editOrganization.profileContract.description === undefined ? '' : editOrganization.profileContract.description,
                [Validators.maxLength(1024)]
            ),
            federated_organization: new UntypedFormControl({ value: this.organizationData.azureADIssuerUrl == undefined ? false : true, disabled: true }),
        });

        this.cd.detectChanges();
        this.addOrganizationFrom.statusChanges.subscribe((status) => {
            this.formStatusChange.emit(this.addOrganizationFrom.valid);
        });
        this.formStatusChange.emit(this.addOrganizationFrom.valid);
        this.initilizeAutoSearch();
        this.createFormDataInForm();

        // * this condition is for setting up checkbox while adding an organization
        if (this.frdOrg) {
            this.addOrganizationFrom.get('federated_organization').setValue(true);
        }
        this.addOrganizationFrom.setValidators(this.comparisonValidator());
    }

    getDataForAutoComplete(searchString: string, inputName: string) {
        this.managementApiService.getDataForAutoComplete(searchString, inputName).subscribe((result) => {
            if (result.success === true) {
                this.profileAutoCompletionData = result.response;
                this.createDataForAutoComplete(this.profileAutoCompletionData, inputName);
            } else {
                this.user_utility.errorModelPopup(result.message);
            }
        });
    }

    createDataForAutoComplete(data: profileContactModel[], inputName) {
        switch (inputName) {
            case 'firstName':
                this.profileContactFirstName = [];
                for (let x = 0; x < data.length; x++) {
                    let option = new Dropdown();
                    option.firstName = data[x].firstName;
                    option.lastName = data[x].lastName;
                    option.email = data[x].email;
                    this.profileContactFirstName.push(option);
                }
                this.inputAutoComplete.openPanel();
                break;

            case 'lastName':
                this.profileContactLastName = [];
                for (let x = 0; x < data.length; x++) {
                    this.profileContactLastName.push({
                        firstName: data[x].firstName,
                        lastName: data[x].lastName,
                        email: data[x].email,
                    });
                }
                this.inputAutoComplete.openPanel();
                break;

            case 'email':
                this.profileContactEmail = [];
                for (let x = 0; x < data.length; x++) {
                    this.profileContactEmail.push({
                        firstName: data[x].firstName,
                        lastName: data[x].lastName,
                        email: data[x].email,
                    });
                }
                this.inputAutoComplete.openPanel();
                break;
        }
    }

    onEnter(event, inputName: string) {
        if (event.source.selected) {
            let temp = event.source.value;
            let flag = true;
            switch (inputName) {
                case 'firstName':
                    this.profileAutoCompletionData.forEach((item) => {
                        if (item.firstName === temp && flag) {
                            this.currentProfileAutoComplete = item;
                            this.autoCompleteTheForm(inputName);
                            flag = false;
                            this.isAutoComplete = true;
                            this.profileContactEmail = [];
                            this.profileContactLastName = [];
                        }
                    });
                    break;
                case 'lastName':
                    this.profileAutoCompletionData.forEach((item) => {
                        if (item.lastName === temp && flag) {
                            this.currentProfileAutoComplete = item;
                            this.autoCompleteTheForm(inputName);
                            flag = false;
                            this.isAutoComplete = true;
                            this.profileContactFirstName = [];
                            this.profileContactEmail = [];
                        }
                    });
                    break;
                case 'email':
                    this.profileAutoCompletionData.forEach((item) => {
                        if (item.email === temp && flag) {
                            this.currentProfileAutoComplete = item;
                            this.autoCompleteTheForm(inputName);
                            flag = false;
                            this.isAutoComplete = true;
                            this.profileContactFirstName = [];
                            this.profileContactLastName = [];
                        }
                    });
                    break;
            }
        }
    }

    autoCompleteTheForm(inputName: string) {
        this.addOrganizationFrom.get('contact_holder_first_name').setValue(this.currentProfileAutoComplete.firstName);
        this.addOrganizationFrom.get('contact_holder_last_name').setValue(this.currentProfileAutoComplete.lastName);
        this.addOrganizationFrom.get('contact_holder_job_title').setValue(this.currentProfileAutoComplete.jobTitle);
        this.addOrganizationFrom.get('contact_holder_telephone').setValue(this.currentProfileAutoComplete.telephone);
        this.addOrganizationFrom.get('contact_holder_email').setValue(this.currentProfileAutoComplete.email);
        this.addOrganizationFrom.get('contact_holder_address_line1').setValue(this.currentProfileAutoComplete.address.line1);
        this.addOrganizationFrom.get('contact_holder_address_line2').setValue(this.currentProfileAutoComplete.address.line2);
        this.addOrganizationFrom.get('contact_holder_city').setValue(this.currentProfileAutoComplete.address.city);
        this.addOrganizationFrom.get('contact_holder_state').setValue(this.currentProfileAutoComplete.address.state);
        this.addOrganizationFrom.get('contact_holder_country').setValue(this.currentProfileAutoComplete.address.country);
        this.addOrganizationFrom.get('contact_holder_zipcode').setValue(this.currentProfileAutoComplete.address.zipcode);
    }

    azureADChecked(event: any) {
        // this.isFederatedOrganization = event.checked;
        // this.isFederatedOrganization.emit(event.checked);
        this.organizationDataService.isFederatedOrganization$.next(event.checked);
        this.organizationDataService.isDisableAzureDetailWizard.next(true);
    }

    createFormDataInForm() {
        let body = this.getOrganizationFormValues();
        // this.formData = this.orga
        this.formData.append('organisation[Name]', body.name);
        this.formData.append('organisation[LicenseLimitiDMS]', body.licenseLimitiDMS as unknown as Blob);
        this.formData.append('organisation[InstanceLimit]', body.instanceLimit as unknown as Blob);
        this.formData.append('organisation[LicenseLimitICE]', body.licenseLimitICE as unknown as Blob);
        this.formData.append('organisation[SFDCCustomerNumber]', body.sfdcCustomerNumber);
        this.formData.append('organisation[ProfileContract][Name]', body.profileContract.name);
        this.formData.append('organisation[ProfileContract][Description]', body.profileContract.description);
        this.formData.append('organisation[ProfileContract][StartDate]', body.profileContract.startDate);
        this.formData.append('organisation[ProfileContract][EndDate]', body.profileContract.endDate);
        this.formData.append('organisation[ProfileContract][ProfileContact][FirstName]', body.profileContract.profileContact.firstName);
        this.formData.append('organisation[ProfileContract][ProfileContact][LastName]', body.profileContract.profileContact.lastName);
        this.formData.append('organisation[ProfileContract][ProfileContact][JobTitle]', body.profileContract.profileContact.jobTitle);
        this.formData.append('organisation[ProfileContract][ProfileContact][Telephone]', body.profileContact.telephone);
        this.formData.append('organisation[ProfileContract][ProfileContact][Email]', body.profileContact.email);
        this.formData.append('organisation[ProfileContract][ProfileContact][Address][Line1]', body.profileContact.address.line1);
        this.formData.append('organisation[ProfileContract][ProfileContact][Address][Line2]', body.profileContact.address.line2);
        this.formData.append('organisation[ProfileContract][ProfileContact][Address][City]', body.profileContact.address.city);
        this.formData.append('organisation[ProfileContract][ProfileContact][Address][State]', body.profileContact.address.state);
        this.formData.append('organisation[ProfileContract][ProfileContact][Address][Country]', body.profileContact.address.country);
        this.formData.append('organisation[ProfileContract][ProfileContact][Address][Zipcode]', body.profileContact.address.zipcode);
        if (this.isImgChanged == true) {
            this.formData.append('LogoImage', this.selectedFile);
            this.formData.append('retainImage', 'false');
        }
        // if (this.updateOrganization) {
        // if((this.OrganizationId || this.addOrganizationFrom.dirty) || (this.addOrganizationFrom.dirty && this.organizationData?.organisationId)){
        if (this.organizationData?.organisationId) {
            this.formData.append('organisation[OrganisationId]', this.organizationIds.organisationId);
            this.formData.append('organisation[ProfileContract][ProfileContractId]', this.organizationIds.profileContractId);
            this.formData.append('organisation[ProfileContract][ProfileContact][ProfileContactId]', this.organizationIds.profileContactId);
            this.formData.append('organisation[ProfileContract][ProfileContact][Address][AddressId]', this.organizationIds.addressId);
            // this.formData.append('organisation[IsFederated]',body.isFedrated as unknown as Blob);
        }
        let formDataWithOutFedDetails = new FormData();
        formDataWithOutFedDetails = this.formData;
        this.organizationDataService.setFormDataValuesForOrganization(formDataWithOutFedDetails);
        this.organizationDataService.formData = formDataWithOutFedDetails;
        if (this.addOrganizationFrom.dirty && this.organizationDataService.organizationData?.azureADClientId) {
            this.formData.append('organisation[AzureADIssuerUrl]', this.organizationDataService.organizationData.azureADIssuerUrl);
            this.formData.append('organisation[AzureADInstance]', this.organizationDataService.organizationData.azureADInstance);
            this.formData.append('organisation[AzureADDomain]', this.organizationDataService.organizationData.azureADDomain);
            this.formData.append('organisation[AzureADTenantID]', this.organizationDataService.organizationData.azureADTenantId);
            this.formData.append('organisation[AzureADClientID]', this.organizationDataService.organizationData.azureADClientId);
            this.formData.append('organisation[AzureADClientSecret]', this.organizationDataService.organizationData.azureADClientSecret);
            this.formData.append('organisation[AzureADB2CExtensionAppClientID]', this.organizationDataService.organizationData.azureADB2CExtensionAppClientId);
            this.formData.append('organisation[AzureADCallbackPath]', this.organizationDataService.organizationData.azureADCallbackPath);
            this.formData.append('organisation[IsFederated]', true as unknown as Blob);
        }
    }

    initilizeAutoSearch() {
        this.addOrganizationFrom
            .get('contact_holder_email')
            .valueChanges.pipe(debounceTime(800), distinctUntilChanged())
            .subscribe((value) => {
                if (value !== this.currentProfileAutoComplete?.email) {
                    this.isAutoComplete = false;
                    this.profileContactFirstName = [];
                }
                if (value.length > 2 && !this.isAutoComplete) {
                    this.getDataForAutoComplete(value, 'email');
                } else if (value.length === 0) {
                    this.profileContactEmail = [];
                }
            });

        this.addOrganizationFrom
            .get('contact_holder_first_name')
            .valueChanges.pipe(debounceTime(800), distinctUntilChanged())
            .subscribe((searchText: string) => {
                if (searchText !== this.currentProfileAutoComplete?.firstName) {
                    this.isAutoComplete = false;
                }
                if (searchText.length > 2 && !this.isAutoComplete) {
                    this.getDataForAutoComplete(searchText, 'firstName');
                } else if (searchText.length === 0) {
                    this.profileContactFirstName = [];
                }
            });

        this.addOrganizationFrom
            .get('contact_holder_last_name')
            .valueChanges.pipe(debounceTime(800), distinctUntilChanged())
            .subscribe((searchText: string) => {
                if (searchText !== this.currentProfileAutoComplete?.lastName) {
                    this.isAutoComplete = false;
                    this.profileContactFirstName = [];
                }
                if (searchText.length > 2 && !this.isAutoComplete) {
                    this.getDataForAutoComplete(searchText, 'lastName');
                } else if (searchText.length === 0) {
                    this.profileContactLastName = [];
                }
            });
    }

    setOrganizationIds() {
        this.organizationIds.organisationId = this.organizationData.organisationId;
        this.organizationIds.profileContractId = this.organizationData.profileContract.profileContractId;
        this.organizationIds.profileContactId = this.organizationData.profileContract.profileContact.profileContactId;
        this.organizationIds.addressId = this.organizationData.profileContract.profileContact.address.addressId;

        this.organizationDataService.formData.append('organisation[OrganisationId]', this.organizationData.organisationId);
        this.organizationDataService.formData.append(
            'organisation[ProfileContract][ProfileContractId]',
            this.organizationData.profileContract.profileContractId
        );
        this.organizationDataService.formData.append(
            'organisation[ProfileContract][ProfileContact][ProfileContactId]',
            this.organizationData.profileContract.profileContact.profileContactId
        );
        this.organizationDataService.formData.append(
            'organisation[ProfileContract][ProfileContact][Address][AddressId]',
            this.organizationData.profileContract.profileContact.address.addressId
        );
    }

    // // * api call to add the user security roles
    addDefaultSecurityRoles() {
        this.managementApiService
            .getSecurityRolesPermissionTemplate(true)
            .pipe(
                switchMap((res) => {
                    if (res.success) {
                        return this.managementApiService
                            .addSecurityRole(this.organizationData.organisationId, res.response)
                            .pipe(tap((res) => this.organizationDataService.setUserSecurityRoles(res.response)));
                    } else if (res.isCustom) {
                        this.user_utility.errorModelPopup(res.message);
                        this.ngxUiLoaderService.stop();
                    }
                })
            )
            .toPromise()
            .catch((error) => {
                this.ngxUiLoaderService.stop();
            });
    }

    // * helper method to trigger an email
    triggerEmail() {
        let payload = new EmailNewOrgAdd();
        payload.lastName = this.organizationData.profileContract.profileContact?.lastName;
        payload.firstName = this.organizationData.profileContract.profileContact.firstName
            ? this.organizationData.profileContract.profileContact.firstName
            : '';
        payload.email = this.organizationData.profileContract.profileContact.email;
        payload.organizationName = this.organizationData.name;
        this.emailSenderService.emailHandler(EmailType.NewOrgAdded, [this.organizationData.profileContract.profileContact.email], payload).subscribe(
            (res) => {
                if (res.success) {
                    // TODO Email sent successfully
                }
            },
            (err) => {
                // TODO Error while sending the email
            }
        );
    }

    public comparisonValidator(): ValidatorFn {
        return (group: UntypedFormGroup): ValidationErrors => {
            const control1 = group.controls['number_of_ICE_licenses'];
            const control2 = group.controls['number_of_iDMS_licenses'];

            if ((control1.value <= 0 && control2.value <= 0) || (control2.value <= 0 && control1.value <= 0)) {
                control2.setErrors({ notMatch: 'number_of_ICE_licenses or number_of_iDMS_licenses is required ' });
                control1.setErrors({ notMatch: 'number_of_ICE_licenses or number_of_iDMS_licenses is required ' });
            } else {
                control2.setErrors(null);
                control1.setErrors(null);
            }
            return;
        };
    }

    getCountry(): Observable<any> {
        return this.http.get(this._jsonURL);
    }

    clickCancel() {
        if (this.addOrganizationFrom.dirty) {
            let dialogRef = this.ngbModal.open(ConfirmationDialogComponent, {
                size: 'sm',
            });
            if (this.OrganizationId) {
                dialogRef.componentInstance.modalMessage = 'Your changes are not saved. Are you sure you want to go back?';
            } else {
                dialogRef.componentInstance.modalMessage = 'Your Organization is not saved. Are you sure you want to go back?';
            }
            dialogRef.result
                .then((result) => {
                    if (result === true) {
                        this.router.navigate(['/management/organization']);
                    }
                })
                .catch((e) => {
                    console.warn(e);
                });
        } else {
            this.router.navigate(['/management/organization']);
        }
    }
    private clearState(): void {
        this.OrganizationId = null;
        this.organizationDataService.organizationData = null;
        this.organizationDataService.isOrganzationEdit = false;
        localStorage.removeItem('selectedOrgId');
        localStorage.removeItem('selectedOrganizationName');
        this.globalEmittersService.currentOrg.next(null);
        this.globalEmittersService.currentOrgId.next(null);
        this.orgLogo = null;
        if (this.addOrganizationFrom) {
            this.addOrganizationFrom.reset();
        } else {
            this.createFormControls();
        }
    }
    ngOnDestroy(): void {
        this.organizationDataService.userRoles = [];
        this.organizationDataService.organizationData = null;
        this.organizationDataService.isFedOrg = false;
        this.isFederatedCheckbox = false;
        this.isSubscribe.unsubscribe();
    }
}
